exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bs-report-table[data-v-769d0588]{width:100%;margin-top:4px}.bs-report-table>*[data-v-769d0588]{width:100%}.bs-action-cell[data-v-769d0588]{width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}", ""]);

// exports
